import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=c8d8774c&"
import script from "./Sidebar.vue?vue&type=script&lang=js&"
export * from "./Sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/juodeliai/miskovezis-core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8d8774c')) {
      api.createRecord('c8d8774c', component.options)
    } else {
      api.reload('c8d8774c', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=c8d8774c&", function () {
      api.rerender('c8d8774c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/resources/static/js/app/components/layout/sidebars/Sidebar.vue"
export default component.exports